import React, { useEffect, useState } from 'react';
import { DataManager } from '../../../core/data-manager';
import { toast } from 'react-toastify';



export default function IC_manufacturing_process_model({ data, entity = null, setDataKeyValue }) {

    const location = window.location;


    async function searchListinoFornitore() {
        var constraints = [
            { fieldName: "idItemModel", type: "value", value: data.idItemModel.id },
            { fieldName: "active", type: "value", value: 1 }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('item_model_suppliers', 1, 100, sorting, '', [], constraints);
        if (response.success === 1 && response.body.length > 0) {
            console.log(response);
            var a = response.body[0];
            if (data.nameSupplier !== a.idSupplier.name) {
                setDataKeyValue('nameSupplier', a.idSupplier.name)
            }
            if (data.idSupplier !== a.idSupplier.id) {
                setDataKeyValue('idSupplier', a.idSupplier.id)
            }
            if (parseFloat(data.phasePrice) !== parseFloat(a.price)) {
                setDataKeyValue('phasePrice', parseFloat(a.price))
            }
            if (parseInt(data.phaseLeadtime) !== parseInt(a.leadtime)) {
                setDataKeyValue('phaseLeadtime', parseInt(a.leadtime))
            }
            if (parseInt(data.minQuantity) !== parseInt(a.minQuantity)) {
                setDataKeyValue('minQuantity', parseInt(a.minQuantity))
            }
            if (parseInt(data.maxQuantity) !== parseInt(a.maxQuantity)) {
                setDataKeyValue('maxQuantity', parseInt(a.maxQuantity))
            }
        }
    }



    useEffect(() => {
        if (entity === 'manufacturing_process_model') {
            console.log(data)
            var elementItemModelName = document.getElementById('manufacturing_process_model_field_itemName')
            searchListinoFornitore();
            if (data.idItemModel) {
                if (data.itemName !== data.idItemModel.name) {
                    setDataKeyValue('itemName', data.idItemModel.name)
                }
                elementItemModelName.classList.remove("d-none");
            }
            else {
                elementItemModelName.classList.add("d-none");
            }

        }


    }, [data])




    const [modalCompilerStatus, setModalCompilerStatus] = useState(false)
    const [modalCompilerInitData, setModalCompilerInitData] = useState(null)
    async function openModalCompiler(id) {
        var response = await DataManager.getItem('item_model', id);
        if (response.success === 1) {
            var a = response.body[0];
            setModalCompilerInitData(a)
            setModalCompilerStatus(true)
        }
    }
    function closeModalCompiler() {
        setModalCompilerStatus(false)
    }

    async function modalCompilerSave(el) {
        console.log(el, data.idItemModel.id)
        var response = await DataManager.updateItem('item_model', el, data.idItemModel.id);
        if (response.success === 1) {
            closeModalCompiler();
            toast.success("Articolo aggiornato con successo.", { theme: 'colored' });
        }
        else {
            console.warn(response)
            toast.error("Errore nell'aggiornare l'articolo.", { theme: 'colored' });
        }
        setModalCompilerInitData(null)
    }





    return (
        <>

        </>
    )
};